import ProductList from "../Products/ProductList";

export default function Homepage() {
  return (
    <div>
      <ProductList />
    </div>
  );
}
